import { Delete, Edit } from "@mui/icons-material";

export const getFieldsTypeActions = ({
  navigate,
  routerPaths,
  setSelectedFieldType,
  setSelectedAction,
  setDialogOpen,
}) => [
  {
    icon: Edit,
    tooltip: "Modifica",
    onClick: (rowId) => navigate(`${routerPaths.updateFieldType}/${rowId}`),
  },
  {
    icon: Delete,
    tooltip: "Elimina",
    onClick: (rowId) => {
      setSelectedFieldType(rowId);
      setSelectedAction("delete");
      setDialogOpen(true);
    },
  },
];
